var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronFirst = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3107 12L17.7803 6.53033C18.0732 6.23744 18.0732 5.76256 17.7803 5.46967C17.4874 5.17678 17.0126 5.17678 16.7197 5.46967L10.7197 11.4697C10.4268 11.7626 10.4268 12.2374 10.7197 12.5303L16.7197 18.5303C17.0126 18.8232 17.4874 18.8232 17.7803 18.5303C18.0732 18.2374 18.0732 17.7626 17.7803 17.4697L12.3107 12ZM8.25 5.25C7.83579 5.25 7.5 5.58579 7.5 6V18C7.5 18.4142 7.83579 18.75 8.25 18.75C8.66421 18.75 9 18.4142 9 18V6C9 5.58579 8.66421 5.25 8.25 5.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronFirst);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-first.96aeccd761293d23912f34de36dc39f2.svg";